import { render, staticRenderFns } from "./FeatureTypeDisplay.vue?vue&type=template&id=5023200e&scoped=true"
import script from "./FeatureTypeDisplay.vue?vue&type=script&lang=js"
export * from "./FeatureTypeDisplay.vue?vue&type=script&lang=js"
import style0 from "./FeatureTypeDisplay.vue?vue&type=style&index=0&id=5023200e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023200e",
  null
  
)

export default component.exports